import React, { Component } from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

/**
 * @description
 * @param {string} severity 類型 ex : info || error || warning || success
 * @param {string} text 文字內容
 * @param {string} variant ex : outlined || standard || filled 邊框類型、淺色滿版、深色滿版
 * @param {boolean} icon 最前面是否要有 icon
 * @param {function} onClose 關閉事件 有給的話就會有叉叉按鈕
 * @param {string} action 自定義按鈕
 * @param {string} color 覆盖不同程度提醒的默認顏色
 * @param {object} style 自訂style
 */
class MuiAlert extends Component {
    render() {
        return (
            <Alert
                className='middle justify-content-left'
                variant={this.props.variant === undefined ? "standard" : this.props.variant}
                color={this.props.severity}
                severity={this.props.severity}
                style={{ ...this.props.style, margin: "10px 0" }}
                onClose={this.props.closeEvent !== undefined ? (e) => {
                    this.props.closeEvent({
                        "target": {
                            "id": this.props.id,
                            "name": this.props.name,
                            "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                        }
                    });
                } : null}
                action={this.props.actionBtn !== undefined ? this.props.actionBtn : null}>
                {this.props.title !== undefined ? <AlertTitle>{this.props.title}</AlertTitle> : null}
                {this.props.text}
            </Alert>
        );
    }
}

export {
    MuiAlert
};